/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Taxonomy_RuleInputs */

const en_reference_dataset_taxonomy_rule = /** @type {(inputs: Reference_Dataset_Taxonomy_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxonomy: valid combinations`)
};

/**
* | output |
* | --- |
* | "Taxonomy: valid combinations" |
*
* @param {Reference_Dataset_Taxonomy_RuleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_taxonomy_rule = /** @type {((inputs?: Reference_Dataset_Taxonomy_RuleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Taxonomy_RuleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_taxonomy_rule(inputs)
});